<template>
  <div class="form-radio-component" :class="customClass">
    <label class="form-check-label d-flex align-items-center" :for="id">
      <input
        type="radio"
        :value="inputValue"
        :id="id"
        :checked="isChecked"
        :disabled="disabled"
        @change="$emit('input', $event.target.value)"
      />
      <div class="radio-input mr-2">
        <i class="icon-check"></i>
      </div>
      {{ label }}
    </label>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: [Number, String],
      default: ""
    },
    inputValue: {
      type: [Number, String],
      default: ""
    },
    id: {
      type: [Number, String],
      default: "form-radio-id"
    },
    label: {
      type: String,
      default: ""
    },
    customClass: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isChecked() {
      return `${this.value}` === `${this.inputValue}`;
    }
  }
};
</script>
<style lang="scss" scoped>
.form-radio-component {
  display: flex;
  align-items: center;
  input {
    position: absolute;
    opacity: 0;
    top: 1000;
    left: 1000;
  }

  i {
    display: none;
  }

  .radio-input {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    flex-shrink: 0;
  }

  label {
    cursor: pointer;
  }

  input:checked ~ .radio-input i {
    display: block;
  }
}
</style>
